import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { McTopBar } from "@maersk-global/mds-react-wrapper/components-core/mc-top-bar";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";

const NotAuthorizedExternal = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();


  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/"
    });
  };

  return (
    <div className="mds">
      <McTopBar
        product="Maersk | Unplanned Charges"
         productshort="Maersk"
        style={{
          paddingLeft: "20px",
          height: "64px",
          paddingRight: "20px",
          marginTop: "-5px",
          borderBottom: "1px solid #DBDBDB",
        }}
      >
      </McTopBar>

      <main className="mds-page mds-container" style={{ padding: "2rem", minHeight: "95vh" }}>
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "70vh",
          textAlign: "center"
        }}>

          {/* Error Title */}
          <h1 style={{
            fontSize: "3rem",
            color: "#dc3545",
            marginBottom: "1rem",
            fontWeight: "600"
          }}>
            403 - Access Denied
          </h1>

          {/* Error Message */}
          <p style={{
            fontSize: "1.2rem",
            color: "#666",
            marginBottom: "2rem",
            maxWidth: "600px",
            lineHeight: "1.5"
          }}>
            You do not have the required permissions to access this page. 
            Please contact your system administrator if you believe this is an error.
          </p>

          {/* Contact Information */}
          <div style={{
            backgroundColor: "#f8f9fa",
            border: "1px solid #dee2e6",
            borderRadius: "8px",
            padding: "1.5rem",
            marginBottom: "2rem",
            maxWidth: "500px",
            width: "100%"
          }}>
            <h3 style={{
              fontSize: "1.1rem",
              color: "#495057",
              marginBottom: "1rem",
              fontWeight: "600"
            }}>
              Need Access?
            </h3>
            <p style={{
              color: "#666",
              marginBottom: "0.5rem",
              fontSize: "0.95rem"
            }}>
             Complete the registration process using the link below.
            </p>
          </div>

          {/* Action Buttons */}
          <div style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center"
          }}>
            <McButton
              onClick={() => window.location.href =process.env.REACT_APP_CIAM_REQUEST_ACCESS_URL}
              label="Complete your request"
              appearance="primary"
              fit="medium"

            />
          
          </div>

          {/* Additional Help */}
          <div style={{
            marginTop: "3rem",
            padding: "1rem",
            backgroundColor: "#e7f3ff",
            border: "1px solid #b3d9ff",
            borderRadius: "6px",
            maxWidth: "400px",
            width: "100%"
          }}>
            <p style={{
              color: "#0066cc",
              fontSize: "0.9rem",
              margin: "0",
              fontWeight: "500"
            }}>
              💡 Tip: Make sure you're logged in with the correct account that has been granted access to this system.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotAuthorizedExternal;